/**
 * A route test's clock on the country's day (18/10/2026): start and pinned
 * times are stored on the Danish clock, the window is the country's — put
 * them on the country's clock (the planner's own dkToLocal) before asking
 * whether the first drop lands before the window.
 * For Media Devoted | Created By Ciro Autiero
 */
import { type CountryDay, dkToLocal } from "../time/danish/danish-clock";
import type { RouteTestClock } from "./route-test";

export function routeTestClockOnCountry<T extends Omit<RouteTestClock, "enabled" | "routeTest" | "strategy">>(clock: T, day: CountryDay): T {
  if (!day.tz) return clock;
  const local = (min: number | null | undefined) => (min == null ? min : dkToLocal(min, day));
  return {
    ...clock,
    startAtMin: clock.startMode === "FIXED_TIME" ? (local(clock.startAtMin) ?? null) : clock.startAtMin,
    slots: clock.slots.map((slot) => ({ ...slot, pinnedAtMin: local(slot.pinnedAtMin) })),
  };
}
